import _ from "lodash";
import React from "react";

import {
  LE_COLLECTION,
  UNIT_PLAN,
  ASSESSMENT,
  GLOBAL_FILTER,
  ALL_LE,
  SEARCH_PAGE,
  BOOKMARKS_PAGE,
  TAB_OPTIONS,
  EARLY_YEAR_GRADE_LABELS,
  DP_GRADE_LABELS,
  ALL_AREAS_OF_LEARNING,
  ALL_SUBJECTS,
  NEWLY_ADDED_LE_COLLECTION,
  MOST_POPULAR_LE_COLLECTION,
  NEWLY_ADDED_UNIT_PLAN,
  MOST_POPULAR_UNIT_PLAN,
  QUESTION,
  QUESTION_V2,
  WORKSHEET,
  DP_TAB_OPTIONS,
  TOPIC_PAGE,
  WORKSHEET_ASSESSMENT,
  MOCK_EXAM,
  PRACTICE_WORKSHEET,
  TOPICS_PAGE_FILTERS,
  WORKSHEET_FEED_FILTERS,
  QUESTION_FEED_FILTERS,
  WORKSHEET_SEARCH_FILTERS,
  QUESTION_SEARCH_FILTERS,
  UNIT_FEED_FILTERS,
  LE_FEED_FILTERS,
  LE_COLLECTION_FEED_FILTERS,
  THREE_DOTS,
  FEED_SECTION,
  LIBRARY_TOPIC,
  ROUTE_TO_ENTITY_MAP,
  LANE_ITEM_LOCALES,
  GRADE_11_AND_12,
  SUBJECT_ABBREVIATION_MAP,
  SEARCH_PAGE_FILTERS,
  MYP_GRADE_LABELS,
  TAB_OPTION_LABELS,
  NEWLY_ADDED_ASSESSMENT,
  MOST_POPULAR_ASSESSMENT,
  CONTEXT_CURRICULUM_PROGRAM_ID,
  IB_MYP_CURRICULUM_PROGRAM,
  MYP_FILTER_ENTITIES,
  MYP_LEARNING_OBJECTIVES,
  TOPIC_DEPTH,
  SUB_TOPIC_DEPTH,
  PYP_GRADE_LABELS,
  GRADE_6,
  E_ASSESSMENT,
  CRITERION_BASED_ASSESSMENT,
  ENTITY_TYPE_LEARNING_EXPERIENCE,
  ENTITY_TYPE_WORKSHEET,
  FEED_SECTION_HEADER_LOCALES,
} from "./Constants";
import {
  colors,
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import {
  QUESTION_TYPE_DETAILS,
  GRADE_11,
  GRADE_12,
  GRADE_11_and_12,
} from "Worksheet/modules/WorksheetConstants";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import {
  getLibraryGradesFromCache,
  getStaffGradesFromCache,
  getSubjectTopicsFromCache,
  getMypCriterionFromCache,
} from "./ToddleLibraryGraphqlHelpers";
import {
  getPypPlannerThemeSetNodesFromCache,
  getOrganizationDetailsFromCache,
  getOrganizationCurriculumProgramsFromCache,
  getOrganizationMultiLevelNodeTagsFromCache,
  getPlannerElementSetsOfCurriculumFromCache as getMYPObjectivesFromCache,
} from "modules/CommonGraphqlHelpers";
import {
  getIsUserImpersonated,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { getGlobalGradeUid } from "LearningCourses/modules/Utils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import ACLStore from "lib/aclStore";
import {
  TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY,
  TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY_V2,
  TODDLE_LIBRARY_PERM,
  LIST_AND_ACCESS_ALL_CLASSES_PERMISSION,
  TODDLE_LIBRARY_USER_GRADE_PREFERENCE_PERM,
} from "Constants/permissionConstants";
import { getRethumbUrl, getCurriculumProgramIdFromState } from "Utils";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  DP_1,
  DP_2,
  TODDLE_LIBRARY,
} from "Constants/stringConstants";
import { Avatar, Tooltip } from "@toddle-edu/ds-web";

import {
  EnglishDuotone,
  CivicsDuotone,
  MathsDuotone,
  SportsDuotone,
  ArtDuotone,
  DesignDuotone,
  GlobalContextDuotone,
  SubjectGenericDuotone,
  SciencesDuotone,
  ReflectionAfterTeachingDuotone,
  CognitiveDevelopmentDuotone,
  MathematicsDuotone,
  StudentPendingOutlined,
  AssessmentAddOutlined,
  LanguageLiteratureDuotone,
  LanguageAcquisitionDuotone,
  BiologyDuotone,
  ChemistryDuotone,
  PhysicsDuotone,
  HistoryDuotone,
  SpanishDuotone,
  FrenchDuotone,
  GeographyDuotone,
} from "@toddle-edu/ds-icons";
import {
  getFormattedQuestionTitle,
  isToddleLibraryEnabledForWorksheets,
  getWorksheetQuestionsCount,
} from "Worksheet/modules/WorksheetUtils";
import {
  getIsWorksheetsEnabled,
  isWorksheetMutationsV2Enabled,
  getIsToddleLibraryWorksheetQueriesV2Enabled,
} from "Worksheet/modules/WorksheetFeatureFlags";
import { getScoreDetailsMemoize } from "ScoreCategories/modules/ScoreCategoriesModule";
import { Trans } from "react-i18next";
import { getSettingValue } from "modules/PermissionModule";
import ACLStorage from "lib/aclService";
import { store } from "store/createStore";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { checkIsUnitPlanViewRevampEnabledInLibrary } from "Utils/ACLStoreUtils";

const styles = {
  tooltipContainerStyle: {
    maxWidth: "500px",
    maxHeight: "250px",
    overflowY: "auto",
  },
  valueStyle: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  overlayInnerStyle: {
    maxWidth: "500px",
  },
  forTextStyles: {
    fontWeight: 500,
  },
};

function getSubjectLevel(subjectLevelObject) {
  if (subjectLevelObject) {
    const hasHL = _.some(subjectLevelObject.resolvedMinimalTree?.genericTags, {
      label: "HL",
    });
    const hasSL = _.some(subjectLevelObject.resolvedMinimalTree?.genericTags, {
      label: "SL",
    });

    if (hasHL && !hasSL) {
      return "HL only";
    } else if (hasSL && !hasHL) {
      return "SL only";
    } else if (hasHL && hasSL) {
      return "HL/SL";
    }
  }
  return "HL/SL";
}
function getTaggedTopicsFromSyllabus(syllabusObject) {
  const depthOneNodes = _.filter(
    _.get(syllabusObject, "resolvedMinimalTree.nodes", []),
    {
      depth: 1,
    }
  );
  const resultArray = _.map(depthOneNodes, ({ label }) => label);
  return resultArray;
}

function getPaperTypesLabel(paperTypeObject) {
  // Extracting labels for paperTypes
  const paperTypeLabels = _.map(
    _.get(paperTypeObject, "resolvedMinimalTree.genericTags", []),
    ({ label }) => label
  );

  return paperTypeLabels;
}

function isMockPaper(worksheetTypeObject) {
  if (worksheetTypeObject) {
    const hasMockExam = _.some(
      worksheetTypeObject.resolvedMinimalTree.genericTags,
      { label: "Mock Exam" }
    );
    return hasMockExam;
  }

  return false;
}

export const isMYPLibrary = () => {
  const state = store?.getState();
  const globalFilter = _.get(state, "toddleLibrary.globalFilter", {});
  const { grade } = globalFilter;
  return _.includes(MYP_GRADE_LABELS, grade?.label);
};

export const getGradeIdFromGlobalFilter = () => {
  const state = store?.getState();
  const globalFilter = _.get(state, "toddleLibrary.globalFilter", {});
  const { grade } = globalFilter;
  return _.get(grade, "id", "");
};

export const getMypCurriculumProgramId = ({
  portalType = "COMMUNITY",
} = {}) => {
  const { org_id: organizationId } = getUserInfo({ portalType });
  const curriculumPrograms = _.get(
    getOrganizationCurriculumProgramsFromCache(organizationId),
    "curriculumPrograms",
    []
  );
  return _.get(
    _.find(curriculumPrograms, { type: CURRICULUM_TYPE_MYP }),
    "id",
    ""
  );
};

export const getCriterion = learningObjectivesMyp => {
  const isMYP = isMYPLibrary();

  if (!learningObjectivesMyp || !isMYP) return [];

  const mypProgramId = getMypCurriculumProgramId();

  const allCriterion = _.get(
    getMypCriterionFromCache({ curriculumProgramId: mypProgramId }),
    "plannerElementSets.[0].nodes",
    []
  );
  const selectedIds = _.get(learningObjectivesMyp, "value", []);

  return _.chain(allCriterion)
    .filter(node => _.includes(selectedIds, node.id))
    .map("label")
    .value();
};

export const getToddleLibraryWorksheetDetails = (
  node,
  entityType = WORKSHEET_ASSESSMENT,
  fieldParent = "allFields"
) => {
  const subjects = _.get(node, "librarySubjects", []);
  const showLibraryPremiumBannerForUser = _.get(
    node,
    "showLibraryPremiumBannerForUser",
    false
  );

  const isLibraryPremium = _.get(node, "isLibraryPremium", false);

  const isMYPGrade = isMYPLibrary();

  const curriculumBasedTopicUid = isMYPGrade
    ? "toddleLibraryTopicsMYP"
    : "syllabusContentDP";

  const isBookmarked =
    entityType == WORKSHEET_ASSESSMENT
      ? _.get(node, "isSavedForLibrary", false)
      : !_.isEmpty(node.savedBy);

  const syllabusObject = node[fieldParent]?.find(
    field => field.uid === curriculumBasedTopicUid
  );

  const paperTypeObject = node[fieldParent]?.find(
    field => field.uid === "worksheetPaperType"
  );

  const worksheetTypeObject = node[fieldParent]?.find(
    field => field.uid === "worksheetType"
  );
  const subjectLevelObject = node[fieldParent]?.find(
    field => field.uid === "subjectLevel"
  );
  const learningObjectivesMyp = node[fieldParent]?.find(
    field => field.uid === "learningObjectivesMyp"
  );
  const paperTypes = getPaperTypesLabel(paperTypeObject);
  const taggedTopics = getTaggedTopicsFromSyllabus(syllabusObject);
  const subjectLevel = getSubjectLevel(subjectLevelObject);
  const isMockExam = isMockPaper(worksheetTypeObject);
  const criterions = getCriterion(learningObjectivesMyp);

  return {
    isBookmarked,
    paperTypes,
    taggedTopics,
    isMockExam,
    subjects,
    subjectLevel,
    isLibraryPremium,
    showLibraryPremiumBannerForUser,
    criterions,
  };
};

const getLEFeedList = ({ entities, entityType }) => {
  return _.map(entities, entity => {
    const { isPremium, isNew, node } = entity;
    const {
      id,
      title: { value: title },
      libraryGrades: grades,
      image,
    } = node;

    const imageUrl = _.get(image, "value", "");
    const questionsV2TypeWiseCount = _.get(
      node,
      "questions.questionTypeWiseCount"
    );
    const questionTypeWiseCount = getIsToddleLibraryWorksheetQueriesV2Enabled()
      ? questionsV2TypeWiseCount
      : _.get(
          node,
          "organizationResourcesV2.resourceTypeBasedCount.questionTypeWiseCount",
          []
        );
    const { maxScore } = getScoreDetailsMemoize({
      assessmentTools: _.get(node, "assessmentTools", []),
    });
    const questionCount = getWorksheetQuestionsCount({
      data: questionTypeWiseCount,
    });
    const worksheetQuestionsData = {
      questionCount,
      totalMarks: parseInt(maxScore),
    };
    const toddleLibraryWorksheetDetails = getToddleLibraryWorksheetDetails(
      node,
      entityType,
      "fields"
    );
    return {
      id,
      type: ASSESSMENT,
      isPremium,
      isNew,
      title,
      grades,
      imageUrl,
      worksheetQuestionsData,
      ...toddleLibraryWorksheetDetails,
    };
  });
};

const getUnitFeedList = entities => {
  return _.map(entities, entity => {
    const { isPremium, isNew, node } = entity;

    const {
      id,
      title: { value: title },
      libraryGrades: grades,
      image,
      librarySubjects: subjects,
      savedBy,
      curriculumProgram,
    } = node;

    const imageUrl = _.get(image, "value", "");
    const isBookmarked = !_.isEmpty(savedBy);

    return {
      id,
      type: UNIT_PLAN,
      isPremium,
      isNew,
      title,
      grades,
      subjects,
      curriculumProgram,
      imageUrl,
      isBookmarked,
      node,
    };
  });
};

const getLECollectionFeedList = entities => {
  return _.map(entities, entity => {
    const { isPremium, isNew, node } = entity;
    const {
      id,
      name: title,
      libraryGrades: grades,
      imageAttachment,
      entities: { totalCount: assessmentCount },
      savedBy,
    } = node;
    const imageUrl = _.get(imageAttachment, "url", "");
    const isBookmarked = !_.isEmpty(savedBy);

    return {
      id,
      type: LE_COLLECTION,
      isPremium,
      isNew,
      title,
      grades,
      imageUrl,
      assessmentCount,
      isBookmarked,
    };
  });
};

const getMockExamFeedList = entities => {
  return _.map(entities, entity => {
    const { isPremium, node } = entity;
    const { id, label: title, worksheet, isSavedForLibrary } = node;
    const papers = getLEFeedList({
      entities: _.get(worksheet, "edges", []),
      entityType: WORKSHEET_ASSESSMENT,
    });

    return {
      id,
      type: MOCK_EXAM,
      isPremium,
      title,
      isBookmarked: isSavedForLibrary,
      papers,
      node,
    };
  });
};

export const getEntityList = (entities, entityType) => {
  switch (entityType) {
    case LE_COLLECTION:
      return getLECollectionFeedList(entities);
    case UNIT_PLAN:
      return getUnitFeedList(entities);
    case WORKSHEET_ASSESSMENT:
    case ASSESSMENT:
      return getLEFeedList({ entities, entityType });
    case MOCK_EXAM:
      return getMockExamFeedList(entities);
    case QUESTION:
    case QUESTION_V2:
    case LIBRARY_TOPIC:
      return entities;
    default:
      return [];
  }
};

export const getLibraryGroupFeedList = laneEntities => {
  return _.map(laneEntities, entity => {
    const {
      label: title,
      metaData: { laneType, entityType, laneOrder },
      entities,
    } = entity;

    const { totalCount: entitiesCount, edges } = entities;

    const entityList = getEntityList(
      edges,
      _.includes(
        [PRACTICE_WORKSHEET, CRITERION_BASED_ASSESSMENT, E_ASSESSMENT],
        laneType
      )
        ? WORKSHEET_ASSESSMENT
        : entityType
    );

    return {
      id: laneType,
      entityType,
      title,
      entitiesCount,
      entityList,
      laneOrder,
      laneType,
    };
  }).filter(entity => !_.isEmpty(entity));
};

const getQuestionFeedListV2 = entities => {
  return _.map(entities, entity => {
    const { isPremium, isNew, node } = entity;
    const {
      id,
      isSavedForLibrary,
      isLibraryPremium,
      showLibraryPremiumBannerForUser,
      parentIdV2,
      parentTypeV2,
      difficulty,
      questionType,
      questionTitle,
      questionScore,
      librarySubjects,
      associatedEntities,
    } = node;

    return {
      isPremium,
      isNew,
      node: {
        id,
        isSavedForLibrary,
        isLibraryPremium,
        showLibraryPremiumBannerForUser,
        parentIdV2,
        parentTypeV2,
        difficulty,
        questionType,
        questionTitle,
        questionScore,
        librarySubjects,
        associatedEntities,
      },
    };
  });
};

const getEntityListV2 = (entities, entityType) => {
  if (_.isEqual(entityType, QUESTION_V2)) {
    return getQuestionFeedListV2(entities);
  }
  return getEntityList(entities, entityType);
};

export const getQuestionFeedList = entities => {
  return _.map(entities, entity => {
    const { isPremium, isNew, node } = entity;
    const {
      id,
      isSavedForLibrary,
      isLibraryPremium,
      showLibraryPremiumBannerForUser,
    } = node;

    const item = _.get(node, "item");

    return {
      isPremium,
      isNew,
      node: {
        id,
        isSavedForLibrary,
        isLibraryPremium,
        showLibraryPremiumBannerForUser,
        item,
      },
    };
  });
};

export const getLibraryGroupFeedListV2 = laneEntities => {
  return _.map(laneEntities, entity => {
    const {
      label: title,
      metaData: { laneType, entityType, laneOrder },
      entities,
    } = entity;

    const { totalCount: entitiesCount, edges } = entities;

    const entityList = getEntityListV2(
      edges,
      _.includes(
        [PRACTICE_WORKSHEET, CRITERION_BASED_ASSESSMENT, E_ASSESSMENT],
        laneType
      )
        ? WORKSHEET_ASSESSMENT
        : entityType
    );

    return {
      id: laneType,
      entityType,
      title,
      entitiesCount,
      entityList,
      laneOrder,
      laneType,
    };
  }).filter(entity => !_.isEmpty(entity));
};

export const isToddleLibraryEnabledForUser = () => {
  const state = store?.getState();
  return _.get(state, "platform.showToddleLibrary", true);
};

export const isToddleLibraryEnabled = ({ checkInternalState = true } = {}) => {
  // If we need to check internal state and the library isn't applicable for the user, return false
  if (checkInternalState && !isToddleLibraryEnabledForUser()) {
    return false;
  }

  if (getIsUserImpersonated()) return false;

  // Otherwise return the module setting value directly
  return ACLStorage.getModuleSettingsValue(TODDLE_LIBRARY_PERM);
};

const isDPGrade = ({ globalGradeUid }) =>
  _.includes([GRADE_11, GRADE_12], globalGradeUid);

export const getIsMYPGrade = ({ globalGradeUid }) => {
  return _.includes(MYP_GRADE_LABELS, globalGradeUid);
};

export const curriculumTypeObj = ({ curriculumType }) => ({
  isPYP: _.isEqual(curriculumType, CURRICULUM_TYPE_PYP),
  isMYP: _.isEqual(curriculumType, CURRICULUM_TYPE_MYP),
  isUBD: _.isEqual(curriculumType, CURRICULUM_TYPE_UBD),
  isDP: _.isEqual(curriculumType, CURRICULUM_TYPE_DP),
});

export const canImportUnitFromToddleLibrary = ({
  curriculumType,
  globalGradeUid,
}) => {
  const { isPYP, isMYP, isUBD } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });
  const isValidCurriculum = isPYP || isMYP || (isUBD && !isGrade11or12);
  return isToddleLibraryEnabled() && isValidCurriculum;
};

export const shouldShowImportFromToddleLibrary = ({ curriculumType }) => {
  const globalGradeUid = getGlobalGradeUid();
  const { isPYP, isMYP, isDP, isUBD } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });
  const isValidCurriculum =
    isPYP ||
    isMYP ||
    isDP ||
    (isUBD && (!isGrade11or12 || showDPLibraryForUBD())); // we show DP library for UBD as well if requested by the org
  return isToddleLibraryEnabled() && isValidCurriculum;
};

export const canImportWorksheetFromToddleLibrary = ({ curriculumType }) => {
  const globalGradeUid = getGlobalGradeUid();
  const { isDP, isUBD, isMYP } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });
  const isWorksheetEnabledForMYPLibrary =
    isMYPWorksheetEnabledForLibrary() && getIsMYPGrade({ globalGradeUid });

  const isValidCurriculum =
    isDP ||
    (isUBD && isGrade11or12 && showDPLibraryForUBD()) ||
    (isMYP && isWorksheetEnabledForMYPLibrary);

  return isToddleLibraryEnabled() && isValidCurriculum;
};

export const canImportLEsFromToddleLibrary = ({
  curriculumType,
  globalGradeUid,
}) => {
  const { isPYP, isMYP, isUBD } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });
  const isValidCurriculum = isPYP || isMYP || (isUBD && !isGrade11or12);
  return isToddleLibraryEnabled() && isValidCurriculum;
};

export const getToddleLibraryEntityTypeFilter = ({
  t,
  curriculumType,
  globalGradeUid,
  endpoint,
}) => {
  const entityTypeFilter = [];

  const { isPYP, isMYP, isUBD } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });

  if ((isPYP || isUBD || isMYP) && !isGrade11or12) {
    entityTypeFilter.push({
      label: t("common:all_label", { label: t("common:le_label_plural") }),
      key: "learning_experience",
    });
  }

  if (
    isToddleLibraryEnabledForWorksheets({
      curriculumType,
      globalGradeUid,
    })
  ) {
    entityTypeFilter.push({
      label: t("common:all_label", { label: t("worksheet:worksheet_other") }),
      key: "worksheet",
    });
  }

  return entityTypeFilter;
};

export const getDefaultEntityType = ({ curriculumType, globalGradeUid }) => {
  const { isPYP, isMYP, isUBD } = curriculumTypeObj({ curriculumType });
  const isGrade11or12 = isDPGrade({ globalGradeUid });
  return (isPYP || isUBD || isMYP) && !isGrade11or12
    ? "learning_experience"
    : "worksheet";
};

export const getGradeOptions = ({
  curriculumProgramType,
  activeEntityType,
} = {}) => {
  const platformUserInfo = getUserInfo({ portalType: "PLANNER" });
  const platformOrgId = platformUserInfo.org_id;

  const organizationGradeDetails = getLibraryGradesFromCache({
    id: platformOrgId,
  });

  const libraryGrades = _.get(organizationGradeDetails, "node.libraryGrades");

  if (_.isEqual(activeEntityType, "worksheet")) {
    let worksheetGradeOptions;
    switch (curriculumProgramType) {
      case CURRICULUM_TYPE_UBD: {
        worksheetGradeOptions = _.filter(libraryGrades, grade => {
          const label = _.get(grade, "label", "");
          return _.includes([GRADE_11, GRADE_12, GRADE_11_and_12], label);
        });
        break;
      }
      case CURRICULUM_TYPE_DP: {
        worksheetGradeOptions = _.filter(libraryGrades, grade => {
          const label = _.get(grade, "label", "");
          return _.includes([DP_1, DP_2, GRADE_11_and_12], label);
        });
        break;
      }
    }

    if (!_.isEmpty(worksheetGradeOptions)) {
      return worksheetGradeOptions;
    }
  }

  // Exclude grades 11 and 12 for MYP worksheet if worksheet feature is enabled
  const hideDPGrades =
    (_.isEqual(curriculumProgramType, CURRICULUM_TYPE_MYP) &&
      isMYPWorksheetEnabledForLibrary() &&
      getIsWorksheetsEnabled() &&
      _.isEqual(activeEntityType, ENTITY_TYPE_WORKSHEET)) ||
    _.isEqual(activeEntityType, ENTITY_TYPE_LEARNING_EXPERIENCE);

  if (hideDPGrades) {
    return _.filter(libraryGrades, grade => {
      const label = _.get(grade, "label", "");
      return !_.isEqual(GRADE_11_AND_12, label);
    });
  }

  return libraryGrades;
};

export const getSubjectOptionsFromGradeId = (
  gradeId,
  omitIcon = true,
  curriculumProgramType,
  activeEntityType
) => {
  const grades = getGradeOptions({ curriculumProgramType, activeEntityType });

  const grade = _.find(grades, grade => grade.id === gradeId);
  const subjects = _.get(grade, "mappedLibraryEntities", []);

  const subjectOptions = subjects.map(subject => {
    const subjectData = omitIcon ? _.omit(subject, "icon") : subject;
    return {
      ...subjectData,
      value: subject.id,
      key: subject.id,
    };
  });

  const label = _.includes(EARLY_YEAR_GRADE_LABELS, grade.label)
    ? ALL_AREAS_OF_LEARNING
    : ALL_SUBJECTS;

  return [{ key: "all", value: "all", label }, ...subjectOptions];
};

export const getSubjectOptionsFromGrades = (
  gradeIds,
  omitIcon = true,
  curriculumProgramType,
  activeEntityType
) => {
  const grades = getGradeOptions({ curriculumProgramType, activeEntityType });
  const subjectOptions = _.flatMap(gradeIds, gradeId => {
    const grade = _.find(grades, grade => grade.id === gradeId);
    const subjects = _.get(grade, "mappedLibraryEntities", []);

    return subjects.map(subject => {
      const subjectData = omitIcon ? _.omit(subject, "icon") : subject;
      return {
        ...subjectData,
        value: subject.id,
        key: subject.id,
      };
    });
  });

  return _.uniqBy(subjectOptions, "id");
};

export const getTopicOptionsFromId = (id, topicsMap = {}, t) => {
  const allOption = { key: "all", value: "all", label: t("common:all") };
  const options = topicsMap[id];

  if (options) {
    return [
      allOption,
      ..._.map(options, ({ id, label }) => ({ key: id, value: id, label })),
    ];
  } else return [allOption];
};

export const getDefaultGradeOfStaff = ({
  curriculumProgramType,
  activeEntityType,
} = {}) => {
  const libraryGrades = getGradeOptions({
    curriculumProgramType,
    activeEntityType,
  });

  const libraryUserInfo = getUserInfo({ portalType: "COMMUNITY" });
  const libraryUserId = libraryUserInfo.id;

  const staffGradesEdges = _.get(
    getStaffGradesFromCache({ id: libraryUserId }),
    "node.libraryEntities.edges",
    []
  );

  const staffGrades = _.map(staffGradesEdges, edge => edge.node);
  const commonGrades = _.intersectionBy(libraryGrades, staffGrades, "id");
  const defaultGrade = _.get(commonGrades, "0", libraryGrades[0]);

  return { ...defaultGrade, key: defaultGrade.id, value: defaultGrade.id };
};

export const getCommonGrades = ({
  curriculumProgramType,
  activeEntityType,
} = {}) => {
  const libraryGrades = getGradeOptions({
    curriculumProgramType,
    activeEntityType,
  });

  const libraryUserInfo = getUserInfo({ portalType: "COMMUNITY" });
  const libraryUserId = libraryUserInfo.id;

  const staffGradesEdges = _.get(
    getStaffGradesFromCache({ id: libraryUserId }),
    "node.libraryEntities.edges",
    []
  );

  const staffGrades = _.map(staffGradesEdges, edge => edge.node);
  const commonGrades = _.intersectionBy(libraryGrades, staffGrades, "id");

  return _.map(commonGrades, grade => ({
    ...grade,
    key: grade.id,
    value: grade.id,
  }));
};

export const findLowestGrade = ({
  commonGrades,
  curriculumLabels,
  libraryGradeOptions,
}) => {
  const lowestGradeOfStaff = _.find(commonGrades, ({ label }) =>
    _.includes(curriculumLabels, label)
  );
  if (lowestGradeOfStaff) return lowestGradeOfStaff;

  return _.find(libraryGradeOptions, ({ label }) =>
    _.includes(curriculumLabels, label)
  );
};

export const getUserGradePerference = () => {
  const userGradeId = getSettingValue({
    name: TODDLE_LIBRARY_USER_GRADE_PREFERENCE_PERM,
  });

  return userGradeId;
};

export const getIsWorksheetModuleEnabledForMYPCurriculum = () => {
  return getSettingValue({
    name: "FeatureFlag:ClassroomWorksheet",
    currentCurriculumProgramId: getMypCurriculumProgramId({
      portalType: "PLANNER",
    }),
  });
};

const setDefaultHomePageTabs = isDPLibrary => {
  return isDPLibrary ? [WORKSHEET, QUESTION] : [ASSESSMENT, UNIT_PLAN];
};

const setDefaultFeedTabs = isDPLibrary => {
  return _.map(isDPLibrary ? DP_TAB_OPTIONS : TAB_OPTIONS, "value");
};

export const getTabsForGrade = ({ gradeId, gradeLabel }) => {
  const configValue = getSettingValue({
    name: TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY,
    portalType: "COMMUNITY",
  });

  const configValueV2 = getSettingValue({
    name: TODDLE_LIBRARY_MANAGE_TABS_VISIBILITY_V2,
    portalType: "COMMUNITY",
  });

  const isDPLibrary = _.isEqual(gradeLabel, "Grade 11 & 12");
  const isMypGrade = isMYPLibrary();
  const isMYPWorksheetEnabled = isMYPWorksheetEnabledForLibrary();
  const configValueToUse = isMYPWorksheetEnabled ? configValueV2 : configValue;

  const isWorksheetsModuleForCurriculumEnabled = getIsWorksheetModuleEnabledForMYPCurriculum();

  let homePageTabs, feedTabs;

  if (configValueToUse?.[gradeId]) {
    const activeTabs = configValueToUse[gradeId];
    homePageTabs = _.get(activeTabs, "HOME_PAGE", []);
    feedTabs = _.get(activeTabs, "FEED", []);
  }

  if (_.isEmpty(homePageTabs)) {
    homePageTabs = setDefaultHomePageTabs(isDPLibrary);
  }

  if (_.isEmpty(feedTabs)) {
    feedTabs = setDefaultFeedTabs(isDPLibrary);
  }

  if (
    isMypGrade &&
    isMYPWorksheetEnabled &&
    !isWorksheetsModuleForCurriculumEnabled
  ) {
    homePageTabs = [UNIT_PLAN];
    feedTabs = [UNIT_PLAN];
  }

  return { homePageTabs, feedTabs };
};

export const filterTypes = {
  [GLOBAL_FILTER]: "globalFilter",
  [ALL_LE]: "leFilter",
  [LE_COLLECTION]: "leFilter",
  [ASSESSMENT]: "leFilter",
  [UNIT_PLAN]: "unitFilter",
  [FEED_SECTION]: "feedFilter",
  [SEARCH_PAGE]: "searchFilter",
  [BOOKMARKS_PAGE]: "bookmarkFilter",
  [NEWLY_ADDED_LE_COLLECTION]: "feedFilter",
  [MOST_POPULAR_LE_COLLECTION]: "feedFilter",
  [NEWLY_ADDED_UNIT_PLAN]: "feedFilter",
  [MOST_POPULAR_UNIT_PLAN]: "feedFilter",
  [NEWLY_ADDED_ASSESSMENT]: "feedFilter",
  [MOST_POPULAR_ASSESSMENT]: "feedFilter",
  [QUESTION]: "questionFilter",
  [WORKSHEET]: "worksheetFilter",
  [TOPIC_PAGE]: "topicFilter",
};

export const getFilterValues = ({
  grade,
  subject,
  selectedTopic,
  ibThemes,
  unitType,
  topic,
  contentType,
  plannerElementThemeSetId,
  hidePrevious = false,
  useHidePreviousFilter = false,
}) => {
  const isMypGrade = _.includes(MYP_GRADE_LABELS, grade.label);
  const isDPGrade = _.includes(DP_GRADE_LABELS, grade.label);
  const isMYPorDPGrade = isMypGrade || isDPGrade;
  const shouldUseAdditionalGradeFilter = getIsAdditionalAllGradesFilterEnabled();
  const allIBThemes = plannerElementThemeSetId
    ? _.get(
        getPypPlannerThemeSetNodesFromCache({
          variables: {
            themeSetId: plannerElementThemeSetId,
          },
        }),
        "nodes",
        []
      )
    : [];
  let filters =
    _.isEmpty(grade) || _.isEqual("all", grade.value)
      ? {}
      : { grades: [grade.value] };
  filters =
    _.isEmpty(subject) || _.isEqual("all", subject.value)
      ? filters
      : { ...filters, subjects: [subject.value] };
  filters = _.isEmpty(selectedTopic)
    ? filters
    : { ...filters, categories: [selectedTopic.id] };
  filters =
    _.isEmpty(ibThemes) ||
    isMypGrade ||
    _.isEqual(allIBThemes.length, ibThemes?.length)
      ? filters
      : { ...filters, ibThemes };
  filters =
    _.isEmpty(unitType) || _.isEqual("all", unitType.value)
      ? filters
      : { ...filters, libraryUnitType: unitType.value };
  filters =
    _.isEmpty(topic) || _.isEqual("all", topic.value) || isMypGrade
      ? filters
      : { ...filters, topics: [topic.value] };

  if (!isMYPorDPGrade || shouldUseAdditionalGradeFilter) {
    filters = _.isEmpty(contentType)
      ? filters
      : { ...filters, contentType: contentType?.value };
  }

  filters =
    useHidePreviousFilter && shouldUseAdditionalGradeFilter
      ? { ...filters, hidePreviouslyUsed: hidePrevious }
      : filters;
  return filters;
};

export const getCountLabelForOption = (
  { value },
  { le, leCollection, unitPlan, question, worksheet, mockExam, eAssessment }
) => {
  const propertyToCountMap = {
    ASSESSMENT: le,
    LE_COLLECTION: leCollection,
    UNIT_PLAN: unitPlan,
    QUESTION: question,
    WORKSHEET: worksheet,
    MOCK_EXAM: mockExam,
    E_ASSESSMENT: eAssessment,
  };

  const selectedValue = _.get(propertyToCountMap, value, 0);
  return selectedValue === -1 ? THREE_DOTS : selectedValue;
};

export const getTabEntity = ({ selectedEntity, isMypGrade }) => {
  const shouldOverrideMYPLabels =
    isMypGrade &&
    isMypFeaturesEnabledForOrg() &&
    _.includes([E_ASSESSMENT, WORKSHEET], selectedEntity);

  if (shouldOverrideMYPLabels) {
    return selectedEntity === WORKSHEET ? "MYP_WORKSHEET" : "MYP_MOCK_EXAM";
  }

  return selectedEntity;
};

const getTabLabelKey = ({ tab, isMypGrade }) => {
  const shouldOverrideMYPLabels =
    isMypGrade &&
    isMypFeaturesEnabledForOrg() &&
    _.includes([E_ASSESSMENT, WORKSHEET], tab);

  if (shouldOverrideMYPLabels) {
    return tab === WORKSHEET
      ? "toddleLibrary:criterion_based_assessments"
      : "toddleLibrary:e_assessments";
  }

  return TAB_OPTION_LABELS[tab];
};

export const getLibraryTabOptionsForGrade = ({
  t,
  gradeId,
  gradeLabel,
  categorisedCount = {},
}) => {
  const { feedTabs } = getTabsForGrade({ gradeId, gradeLabel });
  const isMypGrade = _.includes(MYP_GRADE_LABELS, gradeLabel);

  return _.map(feedTabs, tab => {
    // For MYP grades, if tab is MOCK_EXAM, use E_ASSESSMENT for count
    const countTab =
      isMypGrade && isMypFeaturesEnabledForOrg() && tab === MOCK_EXAM
        ? E_ASSESSMENT
        : tab;
    return {
      label: t(getTabLabelKey({ tab, isMypGrade })),
      value: tab,
      count: getCountLabelForOption({ value: countTab }, categorisedCount),
    };
  });
};

export const getPaginationInfo = entityObject => {
  const totalCount = _.get(entityObject, "totalCount", 0);
  const hasNextPage = _.get(entityObject, "pageInfo.hasNextPage", false);
  const endCursor = _.get(entityObject, "pageInfo.endCursor", null);

  return {
    totalCount,
    hasNextPage,
    endCursor,
  };
};

export const getMoreItemsWithToolTipComponent = (
  items,
  customStyles = {},
  length = 1,
  testId
) => {
  const moreItemsComponent = (
    <MoreItemWithToolTip
      items={items}
      tooltipPlacement={"right"}
      length={length}
      moreAll={true}
      trigger={["hover", "focus"]}
      tooltipContainerStyle={styles.tooltipContainerStyle}
      closeOnScroll={true}
      stopPropagationOnLabelClick={false}
      testId={testId}
      {...customStyles}
    />
  );

  const containerStyles = {
    ...(customStyles.valueStyle ? customStyles.valueStyle : styles.valueStyle),
    ...customStyles.additionalContainerStyle,
  };

  return _.isEqual(items.length, 1) ? (
    <Tooltip tooltip={items[0]} placement={"top"}>
      <div style={containerStyles}>{items[0]}</div>
    </Tooltip>
  ) : (
    moreItemsComponent
  );
};

export const isHomePage = location =>
  _.isEqual(location.pathname, "/toddle-library");

export const isSearchPage = location =>
  _.includes(location.pathname, "/search");

export const isBookmarkedPage = location =>
  _.includes(location.pathname, "/bookmarked");

export const isUnitPage = location => _.includes(location.pathname, "/units");

export const isCollectionView = () => {
  const url = window.location.href;
  // Regex pattern to match "collection/:id"
  const pattern = /\/collection\/[^/]+/;
  return pattern.test(url);
};

export const isHomepageWorkSheetView = location =>
  _.includes(location.pathname, "toddle-library/worksheet");

export const isHomepageQuestionView = location =>
  _.includes(location.pathname, "toddle-library/question");

export const checkIsHomepageLeView = location =>
  _.includes(location.pathname, "toddle-library/assessment") &&
  !_.includes(location.pathname, "/feed-section");

export const itemNavigation = ({
  itemId,
  feedList,
  hasNextPage,
  loadMoreFeed,
  goToRelativeRoute,
  type = ASSESSMENT,
}) => {
  const numberOfItems = feedList.length;
  const currentItemIndex = _.isEqual(type, QUESTION)
    ? _.findIndex(feedList, item => {
        return _.get(item, "node.id") === itemId;
      })
    : _.findIndex(feedList, {
        id: itemId,
      });

  // Hide arrows if the current item is not present in the list.

  // Hide the backward arrow when the current is the first item in the list.
  const showBackwardArrow = currentItemIndex > 0;

  // Hide the forward arrow when the current item is the last item in the list and there is no next page.
  const showForwardArrow =
    (hasNextPage || currentItemIndex < numberOfItems - 1) &&
    currentItemIndex != -1;

  // Route params
  let replacePath = "units";

  switch (type) {
    case ASSESSMENT:
      replacePath = "assessment";
      break;
    case UNIT_PLAN:
      replacePath = "units";
      break;
    case QUESTION:
      replacePath = "question";
      break;
    case WORKSHEET_ASSESSMENT:
      replacePath = "worksheet";
      break;
  }

  const getNewItemRoute = newItem => {
    const id = _.isEqual(type, QUESTION) ? newItem.node.id : newItem.id;
    const searchParams = new URLSearchParams(window.location.search);
    const searchText = searchParams.get("searchText");
    const queryString = searchText ? `?searchText=${searchText}` : "";
    switch (type) {
      case ASSESSMENT:
        return `./assessment/${id}/view${queryString}`;
      case UNIT_PLAN:
        return checkIsUnitPlanViewRevampEnabledInLibrary()
          ? `./units/${id}`
          : `./units/${id}/view`;
      case QUESTION:
        return `./question/${id}`;
      case WORKSHEET_ASSESSMENT:
        return `./worksheet/${id}`;
    }
  };

  const onToggle = async direction => {
    let newIndex = currentItemIndex;

    if (direction === "backward") {
      newIndex = currentItemIndex - 1;
    } else if (direction === "forward") {
      newIndex = currentItemIndex + 1;

      // Load more feed if the current item is the last item in the list.
      if (currentItemIndex === numberOfItems - 1) {
        const { data } = await loadMoreFeed();
        const entityObject = _.get(data, "node.libraryEntities", {});
        const entityEdges = _.get(entityObject, "edges", []);
        const newFeedList = getEntityList(entityEdges, type);
        feedList = [...feedList, ...newFeedList];
      }
    }

    const newItem = feedList[newIndex];
    goToRelativeRoute({
      replacePath,
      type: "push",
      route: getNewItemRoute(newItem),
    });
  };

  return { showBackwardArrow, showForwardArrow, onToggle };
};

export const getIconObject = ({
  size = "x-large",
  containerStyle = {},
  hasBackground = false,
}) => {
  const iconObject = {
    ReflectionAfterTeachingDuotone: {
      iconName: "ReflectionAfterTeachingDuotone",
      color: "teal",
      components: (
        <ReflectionAfterTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SciencesDuotone: {
      iconName: "SciencesDuotone",
      color: "blue",
      components: (
        <SciencesDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    MathsDuotone: {
      iconName: "MathsDuotone",
      color: "violet",
      components: (
        <MathsDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    CivicsDuotone: {
      iconName: "CivicsDuotone",
      color: "teal",
      components: (
        <CivicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ArtDuotone: {
      iconName: "ArtDuotone",
      color: "violet",
      components: (
        <ArtDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    SubjectGenericDuotone: {
      iconName: "SubjectGenericDuotone",
      color: "teal",
      components: (
        <SubjectGenericDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    GlobalContextDuotone: {
      iconName: "GlobalContextDuotone",
      color: "teal",
      components: (
        <GlobalContextDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    DesignDuotone: {
      iconName: "DesignDuotone",
      color: "yellow",
      components: (
        <DesignDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    CognitiveDevelopmentDuotone: {
      iconName: "CognitiveDevelopmentDuotone",
      color: "yellow",
      components: (
        <CognitiveDevelopmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    SportsDuotone: {
      iconName: "SportsDuotone",
      color: "pink",
      components: (
        <SportsDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    EnglishDuotone: {
      iconName: "EnglishDuotone",
      color: "pink",
      components: (
        <EnglishDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    MathematicsDuotone: {
      iconName: "MathematicsDuotone",
      color: "violet",
      components: (
        <MathematicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageLiteratureDuotone: {
      iconName: "LanguageLiteratureDuotone",
      color: "yellow",
      components: (
        <LanguageLiteratureDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageAcquisitionDuotone: {
      iconName: "LanguageAcquisitionDuotone",
      color: "yellow",
      components: (
        <LanguageAcquisitionDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    BiologyDuotone: {
      iconName: "BiologyDuotone",
      color: "blue",
      components: (
        <BiologyDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    ChemistryDuotone: {
      iconName: "ChemistryDuotone",
      color: "blue",
      components: (
        <ChemistryDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PhysicsDuotone: {
      iconName: "PhysicsDuotone",
      color: "blue",
      components: (
        <PhysicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    HistoryDuotone: {
      iconName: "HistoryDuotone",
      color: "teal",
      components: (
        <HistoryDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SpanishDuotone: {
      iconName: "SpanishDuotone",
      color: "yellow",
      components: (
        <SpanishDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    FrenchDuotone: {
      iconName: "FrenchDuotone",
      color: "yellow",
      components: (
        <FrenchDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    GeographyDuotone: {
      iconName: "GeographyDuotone",
      color: "teal",
      components: (
        <GeographyDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
  };
  return iconObject;
};

export const getSortOptions = ({ t }) => [
  { label: t("toddleLibrary:recent"), value: "RECENT", key: "recent" },
  {
    label: t("toddleLibrary:popular"),
    value: "POPULAR",
    key: "popular",
  },
];

const getSubjectLevelForQuestion = (levels = []) => {
  const defaultLevel = "HL/SL";
  const hasHL = _.includes(levels, "HL");
  const hasSL = _.includes(levels, "SL");
  if (hasHL && !hasSL) {
    return "HL only";
  } else if (hasSL && !hasHL) {
    return "SL only";
  } else if (hasHL && hasSL) {
    return defaultLevel;
  }
  return defaultLevel;
};

export const getLibraryQuestionCardDetails = (questionResource, t) => {
  const question = _.get(questionResource, "item");
  const resourceId = _.get(questionResource, "id");
  const questionId = _.get(question, "id", "");
  const questionFields = _.get(question, "fields", []);
  const questionTypeUid = _.get(question, "questionType.uid", "");
  const questionTitle = _.get(question, "questionTitle", {});
  const questionScore = _.get(question, "questionScore", 0);
  const difficultyLevel = _.get(question, "difficulty");

  const questionTypeLabel = t(
    _.get(
      QUESTION_TYPE_DETAILS,
      [questionTypeUid, "localeLabel"],
      "common:untitled"
    )
  );

  const formattedMarks = parseFloat?.(questionScore) || 0;
  const formattedTitle =
    _.get(
      getFormattedQuestionTitle({
        questionTitle,
      }),
      "htmlString",
      false
    ) || t("worksheet:untitled_question");

  const groupedTags = _.groupBy(
    _.get(question, "associatedEntities", []),
    "__typename"
  );
  const subjects = _.map(
    _.get(question, "librarySubjects", []),
    ({ label }) => label
  );
  const genericTags = _.get(groupedTags, "GenericTag", []);
  const tags = _.map(genericTags, ({ label }) => label);
  const [paperTypes, subjectLevels] = _.partition(tags, label =>
    _.includes(label, "Paper")
  );
  const topics = _.map(
    _.filter(_.get(groupedTags, "PlannerElementNode", []), ({ depth }) =>
      _.isEqual(depth, 1)
    ),
    ({ label }) => label
  );
  const subjectLevel = getSubjectLevelForQuestion(subjectLevels);
  const isBookmarked = _.get(questionResource, "isSavedForLibrary", false);

  return {
    key: questionId,
    id: questionId,
    questionTypeLabel,
    marks: formattedMarks,
    title: formattedTitle,
    questionTypeUid,
    subjects,
    topics,
    isBookmarked,
    resourceId,
    paperTypes,
    subjectLevel,
    difficultyLevel,
  };
};

/**
 * V2 version: Question node is returned directly from the feed
 */
export const getLibraryQuestionCardDetailsV2 = (question, t) => {
  const questionId = _.get(question, "id", "");
  const questionTypeUid = _.get(question, "questionType.uid", "");
  const questionTitle = _.get(question, "questionTitle", {});
  const questionScore = _.get(question, "questionScore", 0);
  const difficultyLevel = _.get(question, "difficulty");

  const questionTypeLabel = t(
    _.get(
      QUESTION_TYPE_DETAILS,
      [questionTypeUid, "localeLabel"],
      "common:untitled"
    )
  );

  const formattedMarks = parseFloat?.(questionScore) || 0;
  const formattedTitle =
    _.get(getFormattedQuestionTitle({ questionTitle }), "htmlString", false) ||
    t("worksheet:untitled_question");

  const groupedTags = _.groupBy(
    _.get(question, "associatedEntities", []),
    "__typename"
  );
  const subjects = _.map(
    _.get(question, "librarySubjects", []),
    ({ label }) => label
  );
  const topics = _.map(
    _.filter(_.get(groupedTags, "PlannerElementNode", []), ({ depth }) =>
      _.isEqual(depth, 1)
    ),
    ({ label }) => label
  );
  const isBookmarked = _.get(question, "isSavedForLibrary", false);

  return {
    key: questionId,
    id: questionId,
    questionTypeLabel,
    marks: formattedMarks,
    title: formattedTitle,
    questionTypeUid,
    subjects,
    topics,
    isBookmarked,
    resourceId: questionId,
    difficultyLevel,
    entityType: QUESTION_V2,
  };
};

export const getWorkSheetUseInClassOptions = t => [
  {
    label: t("common:assign_to_students"),
    icon: <StudentPendingOutlined />,
    value: "ASSIGN_WS_TO_STUDENTS",
    key: "ASSIGN_WS_TO_STUDENTS",
  },
  {
    label: t("classRoom:add_to_label", {
      label: t("common:unit"),
    }),
    icon: <AssessmentAddOutlined />,
    value: "ADD_WS_TO_UNIT",
    key: "ADD_TO_EXISTING_WS_IN_UNIT",
  },
];

export const getSubjectLevelsWithLabels = (levels = []) => {
  const subjectLevelQueryVariables = {
    organizationId: "-7",
    filters: {
      types: ["SUBJECT_LEVEL"],
    },
  };

  const subjectLevelData = getOrganizationMultiLevelNodeTagsFromCache(
    subjectLevelQueryVariables
  );

  const subjectLevels = _.get(subjectLevelData, "genericTagsV2", []);

  if (_.isEmpty(levels) || _.isEmpty(subjectLevels)) {
    return [];
  }

  const subjectLevelLableMap = {};
  _.forEach(subjectLevels, ({ id, label }) => {
    subjectLevelLableMap[id] = label;
  });
  return _.map(levels, subjectLevelId => ({
    id: subjectLevelId,
    label: subjectLevelLableMap[subjectLevelId],
  }));
};

const buildIntersectionFields = (fields, options) => {
  const { idKey = "key", resultKeys = {} } = options || {};
  return _.reduce(
    fields,
    (result, field) => {
      const ids = _.compact(_.map(field.data, idKey));
      if (!_.isEmpty(ids)) {
        result.push(
          resultKeys.type
            ? {
                [resultKeys.id]: ids,
                [resultKeys.type]: field.type,
              }
            : {
                [resultKeys.id]: ids,
                [resultKeys.fieldUid]: field.fieldUid,
              }
        );
      }
      return result;
    },
    []
  );
};

const getPlannerElementNodeIntersectionSet = ({
  relatedConcepts,
  keyConcepts,
  globalContext,
  criterion,
}) => {
  const intersectionFields = [
    {
      data: relatedConcepts,
      type: _.get(MYP_FILTER_ENTITIES, "MYP_RELATED_CONCEPT"),
    },
    { data: keyConcepts, type: _.get(MYP_FILTER_ENTITIES, "MYP_KEY_CONCEPT") },
    {
      data: globalContext,
      type: _.get(MYP_FILTER_ENTITIES, "MYP_GLOBAL_CONTEXT"),
    },
    { data: criterion, type: MYP_LEARNING_OBJECTIVES },
  ];

  return buildIntersectionFields(intersectionFields, {
    idKey: "key",
    resultKeys: {
      id: "plannerElementNodeIds",
      type: "plannerElementNodeType",
    },
  });
};

export const getQuestionFilters = ({
  topics,
  subTopics,
  paperTypes,
  difficulty,
  hidePrevious = false,
  areAllTopicsSelected,
  subjectLevels,
  relatedConcepts,
  questionTypes,
  keyConcepts,
  globalContext,
  criterion,
}) => {
  const shouldUseAdditionalGradeFilter = getIsAdditionalAllGradesFilterEnabled();
  const topicItems = _.isEmpty(subTopics)
    ? areAllTopicsSelected
      ? []
      : topics
    : _.map(subTopics, ({ value }) => value);

  let filters = _.isEmpty(topicItems)
    ? {}
    : { plannerElementNodes: topicItems };

  filters = _.isEmpty(difficulty)
    ? filters
    : { ...filters, difficulty: _.map(difficulty, ({ value }) => value) };

  filters = _.isEmpty(paperTypes)
    ? filters
    : { ...filters, paperTypes: _.map(paperTypes, ({ value }) => value) };

  filters = !shouldUseAdditionalGradeFilter
    ? { ...filters, hidePreviouslyUsedQuestions: hidePrevious }
    : filters;

  filters =
    _.isEmpty(subjectLevels) || _.isEqual(subjectLevels?.length, 2)
      ? filters
      : {
          ...filters,
          subjectLevels: getSubjectLevelsWithLabels(subjectLevels),
        };

  filters = _.isEmpty(questionTypes)
    ? filters
    : { ...filters, questionTypes: _.map(questionTypes, ({ value }) => value) };

  const plannerElementNodeIntersectionSet = getPlannerElementNodeIntersectionSet(
    {
      relatedConcepts,
      keyConcepts,
      globalContext,
      criterion,
    }
  );

  if (!_.isEmpty(plannerElementNodeIntersectionSet)) {
    filters.plannerElementNodeIntersectionSet = plannerElementNodeIntersectionSet;
  }
  return filters;
};
export const getWorksheetPlannerElementNodeIntersectionSet = ({
  relatedConcepts,
  keyConcepts,
  globalContext,
  criterion,
}) => {
  const intersectionFields = [
    { data: relatedConcepts, fieldUid: "relatedConceptsMYP" },
    { data: keyConcepts, fieldUid: "conceptsMYP" },
    { data: globalContext, fieldUid: "globalContextMYP" },
    { data: criterion, fieldUid: "learningObjectivesMyp" },
  ];

  return buildIntersectionFields(intersectionFields, {
    idKey: "key",
    resultKeys: { id: "fieldValue", fieldUid: "fieldUid" },
  });
};

export const getWorksheetFilters = ({
  isMypGrade,
  types,
  topics,
  paperTypes,
  subjectLevels,
  areAllTopicsSelected,
  globalContext,
  relatedConcepts,
  keyConcepts,
  criterion,
  subTopics,
}) => {
  let filters = {};
  filters = _.isEmpty(types) ? filters : { ...filters, types };

  const topicItems = _.isEmpty(subTopics)
    ? areAllTopicsSelected
      ? []
      : topics
    : _.map(subTopics, ({ value }) => value);

  if (!_.isEmpty(topicItems)) {
    filters = isMypGrade
      ? { ...filters, mypTopics: topicItems }
      : { ...filters, topics: topicItems };
  }
  filters = _.isEmpty(paperTypes) ? filters : { ...filters, paperTypes };
  filters =
    isMypGrade || _.isEmpty(subjectLevels)
      ? filters
      : { ...filters, subjectLevels };

  const worksheetPlannerElementNodeIntersectionSet = getWorksheetPlannerElementNodeIntersectionSet(
    {
      relatedConcepts,
      keyConcepts,
      globalContext,
      criterion,
    }
  );

  if (!_.isEmpty(worksheetPlannerElementNodeIntersectionSet)) {
    filters.worksheetPlannerElementNodeIntersectionSet = worksheetPlannerElementNodeIntersectionSet;
  }
  return filters;
};

export const getColoredDifficultyLevelLabel = (
  difficulty,
  t,
  showColoredLabel = true
) => {
  switch (difficulty) {
    case "EASY":
      return showColoredLabel ? (
        <div style={{ color: colors.teal400 }}>{t("worksheet:easy")}</div>
      ) : (
        t("worksheet:easy")
      );
    case "MEDIUM":
      return showColoredLabel ? (
        <div style={{ color: colors.yellow300 }}>{t("worksheet:medium")}</div>
      ) : (
        t("worksheet:medium")
      );
    case "HARD":
      return showColoredLabel ? (
        <div style={{ color: colors.red52 }}>{t("worksheet:hard")}</div>
      ) : (
        t("worksheet:hard")
      );
  }
};

export const getDifficultyLevelOptions = (t, showColoredLabel = false) => {
  return [
    {
      label: showColoredLabel ? (
        <div style={{ color: colors.teal400 }}>{t("worksheet:easy")}</div>
      ) : (
        t("worksheet:easy")
      ),
      value: "EASY",
      key: "EASY",
      localeLabel: t("worksheet:easy"),
    },
    {
      label: showColoredLabel ? (
        <div style={{ color: colors.yellow300 }}>{t("worksheet:medium")}</div>
      ) : (
        t("worksheet:medium")
      ),
      value: "MEDIUM",
      key: "MEDIUM",
      localeLabel: t("worksheet:medium"),
    },
    {
      label: showColoredLabel ? (
        <div style={{ color: colors.red52 }}>{t("worksheet:hard")}</div>
      ) : (
        t("worksheet:hard")
      ),
      value: "HARD",
      key: "HARD",
      localeLabel: t("worksheet:hard"),
    },
  ];
};

export const getWorksheetTypeOptions = t => {
  return [
    {
      label: t("toddleLibrary:practice_worksheets"),
      value: "PRACTICE_WORKSHEET",
      key: "PRACTICE_WORKSHEET",
    },
    {
      label: t("toddleLibrary:mock_exams"),
      value: "MOCK_EXAM",
      key: "MOCK_EXAM",
    },
  ];
};

export const getQuestionUseInClassOptions = (t, recentWorksheetDetails) => {
  const isLearningCourseEnabled = getIsLearningCoursesEnabled();

  let options = [
    {
      label: t("toddleLibrary:add_to_existing_ws_in_unit"),
      value: "ADD_TO_EXISTING_WS_IN_UNIT",
      key: "ADD_TO_EXISTING_WS_IN_UNIT",
    },
    {
      label: t("toddleLibrary:add_to_existing_ws_in_assignments"),
      value: "ADD_TO_EXISTING_WS_IN_CLASS",
      key: "ADD_TO_EXISTING_WS_IN_CLASS",
    },
    {
      label: t("toddleLibrary:add_to_new_ws"),
      value: "ADD_TO_NEW_WS",
      key: "ADD_TO_NEW_WS",
    },
  ];

  if (isLearningCourseEnabled) {
    options = [
      {
        label: t(
          "toddleLibrary:add_question_to_a_existing_worksheet_in_a_label",
          { label: t("common:course_lowercase") }
        ),
        value: "ADD_TO_EXISTING_WS_IN_COURSE",
        key: "ADD_TO_EXISTING_WS_IN_COURSE",
      },
      {
        label: t(
          "toddleLibrary:add_question_to_a_existing_worksheet_in_a_label",
          { label: t("common:class_lowercase") }
        ),
        value: "ADD_TO_EXISTING_WS_IN_CLASS_2P0",
        key: "ADD_TO_EXISTING_WS_IN_CLASS_2P0",
      },
      {
        label: t("toddleLibrary:add_to_new_ws"),
        value: "ADD_TO_NEW_WS",
        key: "ADD_TO_NEW_WS",
      },
    ];
  }

  if (!_.isEmpty(recentWorksheetDetails)) {
    options.unshift({
      isItemGroup: true,
      key: "RECENT_WORKSHEET",
      label: t("toddleLibrary:recent_worksheet"),
      options: [
        {
          key: "RECENT_WORKSHEET_OPTION",
          label: recentWorksheetDetails.title,
          icon: (
            <Avatar
              name="Work Sheet"
              size="medium"
              shape="square"
              color="violet"
              shade="light"
            />
          ),
        },
      ],
    });
  }
  return options;
};

export const getAssignmentModalData = t => ({
  mode: "create",
  creationMode: "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS",
  steps: [
    {
      label: t("common:select_with_label", {
        label: getIsLearningCoursesEnabled()
          ? t("common:learning_course")
          : t("common:class"),
      }),
      value: "CLASS_SELECTION",
    },
    {
      label: t("common:edit_with_label", {
        label: t("common:details"),
      }),
      value: "WORKSHEET_QUESTION_CREATION",
    },
    {
      label: t("common:edit_with_label", {
        label: t("common:question_plural"),
      }),
      value: "QUESTION_CREATION",
    },
    {
      label: t("classRoom:assign_settings"),
      value: "SETTINGS",
      heading: t("classRoom:assign_settings"),
      subHeading: t("classRoom:classes_discussion_shared_with"),
    },
  ],
  contentType: "ASSESSMENT",
  createHeader: getIsLearningCoursesEnabled()
    ? t("toddleLibrary:add_ws_to_course")
    : t("toddleLibrary:add_ws_to_class"),
});

export const getStepsForQuestionImportToExistingWS = t => {
  const isLearningCourseEnabled = getIsLearningCoursesEnabled();

  let steps = [
    {
      label: t("common:select_a_with_label", {
        label: t("common:unit_label"),
      }),
      value: "UNIT_SELECTION",
    },
    {
      label: t("common:select_a_with_label", {
        label: t("common:worksheet"),
      }),
      value: "WORKSHEET_SELECTION",
    },
  ];

  if (isLearningCourseEnabled) {
    steps = [
      {
        label: t("common:select_with_label", {
          label: getIsLearningCoursesEnabled()
            ? t("common:learning_course")
            : t("common:class"),
        }),
        value: "CLASS_SELECTION",
      },
      {
        label: t("common:select_a_with_label", {
          label: t("common:worksheet"),
        }),
        value: "WORKSHEET_SELECTION",
      },
    ];
  }

  return steps;
};

export const getStepsForQuestionImportToWSInClass2p0 = t => {
  const steps = [
    {
      label: t("common:select_with_label", {
        label: t("common:class"),
      }),
      value: "CLASS_SELECTION_WITH_COURSE",
    },
    {
      label: t("common:select_a_with_label", {
        label: t("common:worksheet"),
      }),
      value: "WORKSHEET_SELECTION",
    },
  ];

  return steps;
};

export const getAssignmentModalDataForQuestion = t => {
  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
  return {
    mode: "create",
    creationMode: "CREATE_WORKSHEET_FROM_TODDLE_LIBRARY",
    initialStep: "WORKSHEET_QUESTION_CREATION",
    steps: [
      {
        label: t("common:select_with_label", {
          label: isLearningCoursesEnabled
            ? t("common:learning_course")
            : t("common:class"),
        }),
        value: "CLASS_SELECTION",
      },
      {
        label: "Details",
        value: "WORKSHEET_QUESTION_CREATION",
        heading: "Share resource(s)",
        subHeading: "Placeholder for subtext",
      },
      {
        label: "Questions",
        value: "QUESTION_CREATION",
        heading: "Questions",
        subHeading: "Classes this discussion will be shared with",
      },
      {
        label: "Assign settings",
        value: "SETTINGS",
        heading: "Assign settings",
        subHeading: "Classes this discussion will be shared with",
      },
    ],
    contentType: "ASSESSMENT",
    createHeader: t("toddleLibrary:create_worksheet"),
  };
};

export const isDPLibraryRoute = () => {
  const url = window.location.href;
  const urlSegments = url.split("/");
  const hasToddleLibrary = _.includes(urlSegments, "toddle-library");

  if (hasToddleLibrary) {
    const resourceType = _.find(
      urlSegments,
      segment => segment === "question" || segment === "worksheet"
    );

    return !!resourceType;
  }
  return false;
};
export const isMYPLibraryRoute = () => {
  const url = window.location.href;
  const urlSegments = url.split("/");
  const hasToddleLibrary = _.includes(urlSegments, "toddle-library");

  if (hasToddleLibrary) {
    // Extract gradeId from URL query params
    const urlSearchParams = new URLSearchParams(window.location.search);
    const gradeId = urlSearchParams.get("gradeId");
    if (gradeId) {
      // Get all MYP grade ids from grade options
      const mypGradeIds = _.map(
        _.filter(getGradeOptions(), grade =>
          _.includes(MYP_GRADE_LABELS, grade.label)
        ),
        "id"
      );
      if (_.includes(mypGradeIds, gradeId)) {
        // Also check for resourceType in url segments
        const resourceType = _.find(
          urlSegments,
          segment => segment === "question" || segment === "worksheet"
        );
        return !!resourceType;
      }
    }
  }
  return false;
};

export const getAssessmentSectionDetails = ({ assessment }) => {
  const organizationResourceV2Edges = _.get(
    assessment,
    "organizationResourcesV2.edges",
    []
  );

  const sections = _.get(
    organizationResourceV2Edges,
    "0.node.childrenV2.edges",
    []
  );
  const lastSection = _.last(sections);
  const lastSectionId = _.get(lastSection, "node.id", "");
  const parentItemId = _.get(lastSection, "node.item.id", "");

  const questions = _.get(lastSection, "node.childrenV2.edges", []);
  const lastQuestion = _.last(questions);
  const lastQuestionId = _.get(lastQuestion, "node.id");
  const lastQuestionItemId = _.get(lastQuestion, "node.item.id");

  return {
    parentResourceId: lastSectionId,
    putAfterItemId: isWorksheetMutationsV2Enabled()
      ? lastQuestionItemId
      : lastQuestionId,
    parentItemId,
  };
};

export const getFilterKeyForStorage = ({
  parentEntity,
  source = WORKSHEET,
}) => {
  switch (parentEntity) {
    case WORKSHEET:
      return WORKSHEET_FEED_FILTERS;
    case QUESTION:
      return QUESTION_FEED_FILTERS;
    case UNIT_PLAN:
      return UNIT_FEED_FILTERS;
    case ALL_LE:
      return LE_FEED_FILTERS;
    case LE_COLLECTION:
      return LE_COLLECTION_FEED_FILTERS;
    case SEARCH_PAGE:
      return SEARCH_PAGE_FILTERS[source];
    case TOPIC_PAGE:
      return TOPICS_PAGE_FILTERS[source];
  }
};

export const saveIntoStorage = (key, value) => {
  sessionStorage.setItem(key, value);
};

export const getFromStorage = key => sessionStorage.getItem(key);

export const areLocalFiltersSelected = (filters = {}, globalFilters = []) =>
  _.some(filters, (filter, key) => {
    if (typeof filter === "boolean") return filter;

    const isGlobaFilter = _.includes(globalFilters, key);
    return !isGlobaFilter && !_.isEmpty(filter);
  });

export const getUnitPlanBannerImageContainer = () => {
  return document.querySelector('[class*="ViewUnitPlan__scrollContainer"]')
    ?.childNodes[1];
};

export const getToddlePlayPlannerContainer = () => {
  return document.querySelector('[class*="ViewUnitPlan__scrollContainer"]')
    ?.childNodes[2];
};

export const getLePageMiddlePane = () => {
  return document.querySelector('[class*="MiddlePane__stepList"]');
};

export const getWorksheetMainContainer = () => {
  return document.querySelector('[class*="SectionFeed__feedContainer"]');
};

export const getWorksheetSidebarHeaderContainer = () => {
  return document.querySelector(
    '[class*="SideBar__assessmentViewSidebarHeaderContainer"]'
  );
};

export const getWorksheetSidebarContentContainer = () => {
  return document.querySelector('[class*="SideBar__content"]');
};

export const checkIsUnitFlowPage = url => {
  return _.includes(url, "/view/unitFlow");
};

export const checkIsLeView = url => {
  const pattern = /\/assessment\/[0-9]+\/view/;
  return pattern.test(url);
};

export const checkIsUnitPlanView = url => {
  const pattern = checkIsUnitPlanViewRevampEnabledInLibrary()
    ? /\/units\/\d+(\/view)?(\/.*)?$/
    : /\/units\/\d+\/view(\/.*)?$/;
  return pattern.test(url);
};

export const isLEorUnitPlanView = () => {
  const url = window.location.pathname;
  return checkIsLeView(url) || checkIsUnitPlanView(url);
};

export const checkIsFullScreenMode = location => {
  return _.get(location, "query.target") === "fullscreen";
};

export const checkIsMockExamView = location => {
  const searchString = location.search;
  const searchParams = new URLSearchParams(searchString);
  return searchParams.get("source") === "mock-exam";
};

export const getToddleLibraryVisibilityStatus = ({
  curriculumPrograms,
  perm = TODDLE_LIBRARY_PERM,
}) => {
  // If the library isn't applicable for the user, return false
  if (!isToddleLibraryEnabledForUser()) return false;

  const platformUserInfo = getUserInfo({ portalType: "PLANNER" });
  const platformOrgId = platformUserInfo.org_id;
  const organizationDetails = getOrganizationDetailsFromCache(platformOrgId);
  const grades = _.get(organizationDetails, "grades", []);

  if (getIsUserImpersonated()) return false;

  return _.some(curriculumPrograms, program => {
    const isUBD = _.get(program, "type") === CURRICULUM_TYPE_UBD;

    if (isUBD) {
      const UBDGrades = grades.filter(
        ({ curriculumProgram }) =>
          _.get(curriculumProgram, "type") === CURRICULUM_TYPE_UBD
      );
      const allUBDGradesAre11Or12 = UBDGrades.every(({ globalGrade }) =>
        [GRADE_11, GRADE_12].includes(_.get(globalGrade, "uid"))
      );
      if (allUBDGradesAre11Or12 && !showDPLibraryForUBD()) {
        return false;
      }
    }

    return ACLStorage.getModuleSettingsValueByContext(perm, [
      { entityType: "CURRICULUM_PROGRAM", entityId: program.id },
    ]);
  });
};

export const saveGlobalFilters = ({ globalFilter, params }) => {
  const filterKey = "global-filter";
  const savedFilters = JSON.parse(
    getFromStorage("toddleLibraryFilters") || "{}"
  );
  const filtersToStore = {
    ...savedFilters,
    [filterKey]: { ...globalFilter, ...params },
  };
  saveIntoStorage("toddleLibraryFilters", JSON.stringify(filtersToStore));
};

export const isEarlyYearsGrade = gradeLabel => {
  return _.includes(EARLY_YEAR_GRADE_LABELS, gradeLabel);
};

export const isDpGrade = gradeLabel => {
  return _.includes(DP_GRADE_LABELS, gradeLabel);
};

const getEyGradeIds = () =>
  _.map(
    _.filter(getGradeOptions(), ({ label }) => isEarlyYearsGrade(label)),
    ({ id }) => id
  );

export const getTopicsMap = topics => {
  const libraryEntityMap = {};
  const eyGrades = getEyGradeIds();
  topics.forEach(item => {
    item.libraryEntity.forEach(({ id: entityId, type: entity_type }) => {
      const topic = { id: item.id, label: item.label };

      if (entity_type === "SUBJECT") {
        item.libraryEntity.forEach(
          ({ id: gradeId, type: inner_entity_type }) => {
            if (inner_entity_type === "GRADE") {
              const new_id = `${entityId}_${gradeId}`;
              libraryEntityMap[new_id] = libraryEntityMap[new_id] || [];
              libraryEntityMap[new_id].push(topic);
            }
          }
        );

        if (
          _.size(item.libraryEntity) > 0 &&
          !_.includes(_.map(item.libraryEntity, "type"), "GRADE")
        ) {
          eyGrades.forEach(gradeId => {
            const new_id = `${entityId}_${gradeId}`;
            libraryEntityMap[new_id] = libraryEntityMap[new_id] || [];
            libraryEntityMap[new_id].push(topic);
          });
        }
      } else {
        libraryEntityMap[entityId] = libraryEntityMap[entityId] || [];
        libraryEntityMap[entityId].push(topic);
      }
    });
  });

  return libraryEntityMap;
};

export const getSelectedGradeOrSubjectId = ({ grade, subject }) => {
  return _.isEqual(subject?.value, "all")
    ? grade?.value
    : `${subject?.value}_${grade?.value}`;
};

export const moveItemToFirstIndex = (itemList, itemToMoveToStart) => {
  return _.sortBy(itemList, item => item !== itemToMoveToStart);
};

export const getActiveEntity = location => {
  const pathname = location.pathname;
  const activeRoute = _.last(_.split(pathname, "/"));
  const isMYPGrade = isMYPLibrary();
  const isMypEassessment =
    activeRoute === "mock-exams" && isMYPGrade && isMypFeaturesEnabledForOrg();
  return isMypEassessment
    ? E_ASSESSMENT
    : _.get(ROUTE_TO_ENTITY_MAP, activeRoute, "");
};

const checkIsDpLane = laneType => {
  return _.includes(
    ["QUESTION_BANK", "MOCK_EXAM", "PRACTICE_WORKSHEET"],
    laneType
  );
};

const getDisplayLabelForLane = (grade, subjectObj) => {
  return subjectObj?.value != "all" ? subjectObj?.label : grade;
};

export const getLaneHeadingText = (laneType, gradeLabel, subjectObj) => {
  const isDpLane = checkIsDpLane(laneType);
  const label = getDisplayLabelForLane(gradeLabel, subjectObj);
  const mypLaneTypeMap = {
    [E_ASSESSMENT]: "MYP_MOCK_EXAM",
    [CRITERION_BASED_ASSESSMENT]: "MYP_PRACTICE_WORKSHEET",
  };

  const shouldOverrideMYPLaneLabel =
    _.includes(MYP_GRADE_LABELS, gradeLabel) &&
    _.includes([E_ASSESSMENT, CRITERION_BASED_ASSESSMENT], laneType);

  if (shouldOverrideMYPLaneLabel) {
    laneType = mypLaneTypeMap[laneType] || laneType;
  }

  const styles = {
    fontWeight: "700",
  };

  if (isDpLane) {
    return (
      <Trans i18nKey={LANE_ITEM_LOCALES[laneType]}>
        <span style={styles}>{{ label }}</span>
      </Trans>
    );
  }

  return (
    <Trans i18nKey={LANE_ITEM_LOCALES[laneType]}>
      <span style={styles}>{{ label }}</span>
    </Trans>
  );
};

export const itemCardStyles = {
  ASSESSMENT: {
    parentContainer: {
      height: "264px",
    },
    imageContainer: {
      height: "200px",
    },
  },
  UNIT_PLAN: {
    parentContainer: {
      height: "248px",
    },
    imageContainer: {
      height: "184px",
    },
  },
};

const getLastNDigits = (str, n) => {
  const string = _.toString(str);
  return _.slice(string, -n).join("");
};

export const getImageUrl = ({ id = 0, imageUrl, rethumbParams = {} }) => {
  const imageIndex = getLastNDigits(id, 4) % PLACEHOLDER_RECT_IMAGE_COUNT;

  return !_.isEmpty(imageUrl)
    ? getRethumbUrl(rethumbParams)
    : PLACEHOLDER_RECT_IMAGE[imageIndex % PLACEHOLDER_RECT_IMAGE_COUNT];
};

export const getDefaultFilters = (type = FEED_SECTION, subjectLevels = []) => {
  switch (type) {
    case FEED_SECTION:
      return {
        selectedEntity: "",
        ibThemes: [],
        unitType: {},
        sortBy: {},
        topic: {},
      };
    case SEARCH_PAGE:
      return {
        selectedEntity: "",
        ibThemes: [],
        unitType: {},
        sortBy: {},
        topic: {},
      };
    case WORKSHEET:
      return {
        types: [],
        topics: [],
        subTopics: [],
        subjectLevels,
        paperTypes: [],
        relatedConcepts: [],
        keyConcepts: [],
        globalContext: [],
        criterion: [],
      };
    case QUESTION:
      return {
        topics: [],
        subTopics: [],
        paperTypes: [],
        difficulty: [],
        subjectLevels,
        relatedConcepts: [],
        keyConcepts: [],
        globalContext: [],
        criterion: [],
        questionTypes: [],
        hidePrevious: false,
      };
  }
};

export const saveDefaultFiltersIntoStorage = subjectLevels => {
  const savedFilters = JSON.parse(
    sessionStorage.getItem("toddleLibraryFilters") || "{}"
  );
  const filtersToStore = {
    ...savedFilters,
    [WORKSHEET_FEED_FILTERS]: getDefaultFilters(WORKSHEET, subjectLevels),
    [QUESTION_FEED_FILTERS]: getDefaultFilters(QUESTION, subjectLevels),
    [WORKSHEET_SEARCH_FILTERS]: getDefaultFilters(WORKSHEET, subjectLevels),
    [QUESTION_SEARCH_FILTERS]: getDefaultFilters(QUESTION, subjectLevels),
    [UNIT_FEED_FILTERS]: getDefaultFilters(FEED_SECTION),
    [LE_FEED_FILTERS]: getDefaultFilters(FEED_SECTION),
    [LE_COLLECTION_FEED_FILTERS]: getDefaultFilters(FEED_SECTION),
  };
  saveIntoStorage("toddleLibraryFilters", JSON.stringify(filtersToStore));
};

export const getOrganizationGradeOptions = grades => {
  const options = _.map(grades, ({ id, name }) => ({
    key: id,
    label: name,
  }));

  return [{ key: "all", label: "All" }, ...options];
};

export const getAbbreviatedSubjectName = subjectName => {
  return _.get(SUBJECT_ABBREVIATION_MAP, _.lowerCase(subjectName), subjectName);
};

export const isMypFeaturesEnabledForOrg = () => {
  const isMYPWorksheetEnabled = isMYPWorksheetEnabledForLibrary();
  const isWorksheetsModuleForCurriculumEnabled = getIsWorksheetModuleEnabledForMYPCurriculum();
  return isMYPWorksheetEnabled && isWorksheetsModuleForCurriculumEnabled;
};

export const getHomepageHeaderText = (t, gradeLabel) => {
  const isMypGrade = _.includes(MYP_GRADE_LABELS, gradeLabel);
  const isMYPFeaturesEnabled = isMypFeaturesEnabledForOrg();

  const shouldShowMypBannerText = isMYPFeaturesEnabled && isMypGrade;

  let headerKey = "toddleLibrary:grade_1_to_10_homepage_banner_header";
  if (isEarlyYearsGrade(gradeLabel)) {
    headerKey = "toddleLibrary:early_years_homepage_banner_header";
  } else if (isDpGrade(gradeLabel)) {
    headerKey = "toddleLibrary:dp_homepage_banner_header";
  } else if (shouldShowMypBannerText) {
    headerKey = "toddleLibrary:myp_homepage_banner_header";
  }

  return t(headerKey);
};

export const getGradeIdFromUrl = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get("gradeId") || "";
};

export const getLibraryUrlGradeDetails = () => {
  const isMYPWorksheetEnabled = isMYPWorksheetEnabledForLibrary();
  const isWorksheetsModuleForCurriculumEnabled = getIsWorksheetModuleEnabledForMYPCurriculum();

  if (!isMYPWorksheetEnabled || !isWorksheetsModuleForCurriculumEnabled) {
    // If MYP Worksheet is not enabled, just check DP routes/tabs and return
    const isDpURL =
      isHomepageQuestionView(location) ||
      isHomepageWorkSheetView(location) ||
      isDPTabSelected();
    return { isDpURL, matchedGrade: {} };
  }

  if (isHomepageQuestionView(location) || isHomepageWorkSheetView(location)) {
    const gradeId = getGradeIdFromUrl();
    const platformUserInfo = getUserInfo({ portalType: "PLANNER" });
    const platformOrgId = platformUserInfo.org_id;
    const organizationGradeDetails = getLibraryGradesFromCache({
      id: platformOrgId,
    });
    const libraryGrades = _.get(
      organizationGradeDetails,
      "node.libraryGrades",
      []
    );
    const matchedGrade =
      _.find(libraryGrades, grade => grade.id === gradeId) || {};
    let matchedGradeWithKeys = matchedGrade;
    if (!_.isEmpty(matchedGrade)) {
      matchedGradeWithKeys = {
        ...matchedGrade,
        key: matchedGrade.id,
        value: matchedGrade.id,
      };
    }
    const gradeLabel = _.get(matchedGrade, "label", "");
    const isDpURL = _.isEqual(gradeLabel, GRADE_11_AND_12);
    return { isDpURL, matchedGrade: matchedGradeWithKeys };
  }

  // If not on DP routes, return isDpURL as false and matchedGrade as empty
  return { isDpURL: false, matchedGrade: {} };
};

export const isDPTabSelected = () => {
  return (
    _.includes(location.pathname, "questions") ||
    _.includes(location.pathname, "worksheets") ||
    _.includes(location.pathname, "mock-exams")
  );
};

export const isMYPTabSelectedV2 = () => {
  return (
    _.includes(location.pathname, "units-section") ||
    // _.includes(location.pathname, "questions") ||
    _.includes(location.pathname, "worksheets") ||
    _.includes(location.pathname, "mock-exams")
  );
};

export const isMYPTabSelectedV2Default = () => {
  return _.includes(location.pathname, "units-section");
};

export const isMYPTabSelected = () => {
  return (
    _.includes(location.pathname, "les") ||
    _.includes(location.pathname, "units-section")
  );
};
export const isPYPTabSelected = () => {
  return (
    _.includes(location.pathname, "les") ||
    _.includes(location.pathname, "collections") ||
    _.includes(location.pathname, "units-section")
  );
};

export const shouldSelectDefaultTab = gradeLabel => {
  const isDPLibrary = gradeLabel === GRADE_11_AND_12;
  const isMYPGrade = _.includes(MYP_GRADE_LABELS, gradeLabel);
  let isPYPLibrary = _.includes(PYP_GRADE_LABELS, gradeLabel);

  const isMYPWorksheetEnabled = isMYPWorksheetEnabledForLibrary();
  const isWorksheetsModuleForCurriculumEnabled = getIsWorksheetModuleEnabledForMYPCurriculum();
  if (isMYPWorksheetEnabled && isWorksheetsModuleForCurriculumEnabled) {
    return (
      (isDPLibrary && !isDPTabSelected()) ||
      (isMYPGrade && !isMYPTabSelectedV2()) ||
      (isPYPLibrary && !isPYPTabSelected())
    );
  }
  if (isMYPWorksheetEnabled) {
    return (
      (isDPLibrary && !isDPTabSelected()) ||
      (isMYPGrade && !isMYPTabSelectedV2Default()) ||
      (isPYPLibrary && !isPYPTabSelected())
    );
  }
  isPYPLibrary = gradeLabel === GRADE_6 ? true : isPYPLibrary;

  return (
    (isDPLibrary && !isDPTabSelected()) ||
    (isMYPGrade && !isMYPTabSelected()) ||
    (isPYPLibrary && !isPYPTabSelected())
  );
};

export const getDifficultyLevelLabel = (difficulty, t) => {
  switch (difficulty) {
    case "EASY":
      return <div>{t("worksheet:easy")}</div>;
    case "MEDIUM":
      return <div>{t("worksheet:medium")}</div>;
    case "HARD":
      return <div>{t("worksheet:hard")}</div>;
  }
};

export const getUserName = state => {
  return `${_.get(state, "login.userInfo.first_name", "")} ${_.get(
    state,
    "login.userInfo.last_name",
    ""
  )}`;
};

export const checkIsFeedSection = location => {
  return _.includes(location.pathname, "/feed-section");
};

export const checkHasPypCurriculum = (curriculumPrograms = []) => {
  return _.some(curriculumPrograms, ({ type }) => type === CURRICULUM_TYPE_PYP);
};

export const getBookmarkTooltip = ({ t, isBookmarked }) => {
  return isBookmarked
    ? t("common:remove_with_label", { label: t("common:bookmark") })
    : t("toddleLibrary:bookmark_resource");
};

export const checkTermsExistsForSelectedCurriculumProgram = ({
  selectedCurriculumProgramId,
} = {}) => {
  return (dispatch, getState) => {
    // if feature flag is not enabled, return true
    const state = getState();

    if (!ACLStore.can("FeatureFlag:EnableTermRestriction")) {
      return true;
    }

    const userInfo = getUserInfo({ portalType: "PLANNER" });
    const organizationId = _.get(userInfo, "org_id");
    const curriculumProgramId =
      selectedCurriculumProgramId || getCurriculumProgramIdFromState({ state });
    const orgCurriculumPrograms = getOrganizationCurriculumProgramsFromCache(
      organizationId
    );

    if (_.isEmpty(curriculumProgramId)) {
      return false;
    }

    const curriculumProgram = _.find(
      _.get(orgCurriculumPrograms, "curriculumPrograms", []),
      {
        id: curriculumProgramId,
      }
    );

    const termsCount = _.get(curriculumProgram, "terms.totalCount", 0);
    return termsCount > 0;
  };
};
export const getSubjectTopicsLength = ({ subjectId }) => {
  if (!subjectId) return 0;
  const queryVariables = {
    ids: [subjectId],
    depth: 1,
  };
  const queryData = getSubjectTopicsFromCache(queryVariables);

  const topics = _.get(queryData, "[0].associatedChildPlannerElementNodes", []);
  return topics.length;
};

export const getMypSubjectTopicsLength = ({
  curriculumProgramId,
  gradeIds,
  subjectIds,
}) => {
  const {
    mypObjectivesVariables,
  } = getMYPObjectivesVariablesForTopicsAndSubtopics({
    curriculumProgramId,
    gradeIds,
    subjectIds,
  });

  const nodes = getMYPObjectivesFromCache(mypObjectivesVariables);
  const mypTopics = _.get(nodes, "plannerElementSets.[0].nodes", []);
  return mypTopics.length;
};

export const getSubjectTopicsCount = ({
  isMypGrade,
  subjectId,
  curriculumProgramId,
  gradeIds,
  subjectIds,
}) => {
  if (isMypGrade) {
    return getMypSubjectTopicsLength({
      curriculumProgramId,
      gradeIds,
      subjectIds,
    });
  }
  return getSubjectTopicsLength({ subjectId });
};

export const showGlobalHeaderInLibrary = () => {
  return ACLStore.can("FeatureFlag:EnableToddleLibraryGlobalHeader");
};

export const isMYPWorksheetEnabledForLibrary = () => {
  return ACLStore.can("ToddleLibrary:MYPWorksheet");
};

export const showDPLibraryForUBD = () => {
  return ACLStore.can("FeatureFlag:EnableDPLibraryForUBD");
};

export const extractIdsFromUrlSearchParams = () => {
  const urlSearchParams = new URLSearchParams(location.search);
  const collectionGrade = urlSearchParams.get("collectionGrade");

  return { selectedGradeIdInCollection: collectionGrade };
};

export const getMappedSubject = (subjectEntityList, isMypGrade) => {
  const subject = _.find(
    subjectEntityList,
    entity =>
      _.get(entity, "curriculumProgram.type") ===
      (isMypGrade ? CURRICULUM_TYPE_MYP : CURRICULUM_TYPE_DP)
  );
  return _.get(subject, "id", "");
};

export const getMYPObjectivesVariables = ({
  curriculumProgramId,
  portalType = "COMMUNITY",
  type = IB_MYP_CURRICULUM_PROGRAM,
  elementTypes = [_.get(MYP_FILTER_ENTITIES, "MYP_LIBRARY_TOPICS")],
  depth,
  gradeIds,
  subjectIds,
  parentNodeList = [],
}) => {
  const filters = {
    upToDepth: depth,
    startDepth: depth,
    associatedParents: [
      {
        ids: _.isEmpty(gradeIds) ? [] : gradeIds,
        type: "GRADE",
      },
      {
        ids: _.isEmpty(subjectIds) ? [] : subjectIds,
        type: "SUBJECT",
      },
    ],
  };
  if (parentNodeList.length) {
    filters.parentNodes = parentNodeList;
  }
  return {
    id: curriculumProgramId,
    portalType,
    type,
    elementTypes,
    filters,
  };
};

export const getMYPObjectivesVariablesForTopicsAndSubtopics = ({
  curriculumProgramId,
  gradeIds,
  subjectIds,
  parentNodeList = [],
}) => ({
  mypObjectivesVariables: getMYPObjectivesVariables({
    curriculumProgramId,
    depth: TOPIC_DEPTH,
    gradeIds,
    subjectIds,
  }),
  mypObjectivesSubtopicsVariables: getMYPObjectivesVariables({
    curriculumProgramId,
    depth: SUB_TOPIC_DEPTH,
    gradeIds,
    subjectIds,
    parentNodeList,
  }),
});

export const getVariablesForProgramWideConfigurationsForLibrary = ({
  curriculumPrograms,
}) => {
  const contexts = [];

  const programsCount = _.size(curriculumPrograms);

  for (let i = 0; i < programsCount; i++) {
    const { id } = curriculumPrograms[i];

    const context = [
      {
        entityId: id,
        entityType: "CURRICULUM_PROGRAM",
      },
    ];

    contexts.push(context);
  }

  return {
    filters: {
      module: "TODDLE_LIBRARY",
      appType: ["ADMIN_WEB"],
      contexts,
    },
  };
};

export const getCurriculumProgramsWithAllClassAccess = state => {
  const userInfo = _.get(state, "login.userInfo", {});
  const curriculumPrograms = _.get(userInfo, "userCurriculumPrograms", {});
  const curriculumProgramIds = _.map(curriculumPrograms, "id");

  const organizationCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  return _.reduce(
    curriculumProgramIds,
    (result, curriculumProgramId) => {
      const hasAllClassAccess = ACLStorage.getModuleSettingsValueByContext(
        LIST_AND_ACCESS_ALL_CLASSES_PERMISSION,
        [{ entityType: "CURRICULUM_PROGRAM", entityId: curriculumProgramId }]
      );

      if (hasAllClassAccess) {
        const curriculumProgram = _.find(organizationCurriculumPrograms, {
          id: curriculumProgramId,
        });

        result.push(curriculumProgram);
      }

      return result;
    },
    []
  );
};

export const getCurriculumProgramIdFromType = ({
  curriculumPrograms,
  curriculumProgramType,
}) => {
  const curriculumProgramId = _.get(
    _.find(curriculumPrograms, { type: curriculumProgramType }),
    "id"
  );
  return curriculumProgramId;
};

export const checkHasLibrarySuperAdminAccess = () => {
  return ACLStore.can("FeatureFlag:ToddleLibrarySuperAdminAccess");
};

export const getContextCurriculumProgramId = (
  state,
  isToddleLibrary = true
) => {
  const isPremiumBannerAuthorizationEnabled = ACLStore.can(
    "FeatureFlag:PremiumBannerAuthorizeModuleCheck"
  );

  if (!isPremiumBannerAuthorizationEnabled) return;

  const contextCurriculumProgramId = sessionStorage.getItem(
    CONTEXT_CURRICULUM_PROGRAM_ID
  );

  const selectedCurriculumId = getSelectedCurriculumId(state);

  const activeTab = _.get(state, "login.activeTab", "");

  // it will be "null" bcause we are setting it in ToddleLibrary.js through getSelectedCurriculumId
  // which is null by default. So, after stringify, it becomes "null"
  if (
    activeTab === TODDLE_LIBRARY &&
    !_.includes([null, "null"], contextCurriculumProgramId)
  ) {
    return contextCurriculumProgramId;
  } else if (selectedCurriculumId !== null && isToddleLibrary) {
    return selectedCurriculumId;
  }

  return undefined;
};

export const getLibraryBannerFilters = (state, isToddleLibrary = true) => {
  const contextCurriculumProgramId = getContextCurriculumProgramId(
    state,
    isToddleLibrary
  );
  return contextCurriculumProgramId
    ? { contextCurriculumProgramId }
    : undefined;
};

export const mapToOptionObjects = (selectedIds, options) =>
  _.map(selectedIds, id => {
    const option = _.find(options, { value: id }) || {};
    return {
      key: id,
      value: id,
      label: option.label || id,
    };
  });

// Helper to reduce duplication
export const getMypFilterArray = (keysObj, keyName, options) => {
  return !_.isEmpty(keysObj[keyName])
    ? mapToOptionObjects(keysObj[keyName], options)
    : [];
};

export const getMYPFilterOptionConfigs = () => [
  {
    key: "subTopics",
    labelKey: "worksheet:sub_topic",
    itemsKey: "mypSubTopics",
    showIf: items => !_.isEmpty(items),
    buildOptionsConfig: { parent: "subTopics" },
  },
  {
    key: "topics",
    labelKey: "worksheet:topics",
    itemsKey: "topics",
    showIf: items => !_.isEmpty(items),
    buildOptionsConfig: { parent: "topics" },
  },
  {
    key: "criterion",
    labelKey: "common:criterion",
    itemsKey: "criterion",
    showIf: items => !_.isEmpty(items),
    buildOptionsConfig: { parent: "criterion" },
  },
  {
    key: "keyConcepts",
    labelKey: "common:key_concept",
    itemsKey: "keyConcepts",
    buildOptionsConfig: { parent: "keyConcepts" },
  },
  {
    key: "relatedConcepts",
    labelKey: "common:related_concept",
    itemsKey: "relatedConcepts",
    buildOptionsConfig: { keyPath: "value", parent: "relatedConcepts" },
  },
  {
    key: "globalContext",
    labelKey: "common:global_context",
    itemsKey: "globalContext",
    buildOptionsConfig: { parent: "globalContext" },
  },
  {
    key: "difficulty",
    labelKey: "worksheet:difficulty",
    itemsKey: "difficultyOptions",
    showIf: items => !_.isEmpty(items),
    buildOptionsConfig: {
      keyPath: "key",
      parent: "difficulty",
      extra: (item, key, t) => ({
        label: getDifficultyLevelLabel(key, t),
        localeLabel: _.get(item, "localeLabel", ""),
      }),
    },
  },
  {
    key: "questionTypes",
    labelKey: "worksheet:question_type",
    itemsKey: "questionTypeOptions",
    showIf: items => !_.isEmpty(items),
    buildOptionsConfig: { keyPath: "value", parent: "questionTypes" },
  },
];

export const getMypFilterVariables = curriculumProgramId => ({
  mypRelatedConceptsVariables: {
    id: curriculumProgramId,
    elementTypes: [_.get(MYP_FILTER_ENTITIES, "MYP_RELATED_CONCEPT")],
  },
  mypKeyConceptsVariables: {
    id: curriculumProgramId,
    elementTypes: [_.get(MYP_FILTER_ENTITIES, "MYP_KEY_CONCEPT")],
  },
  mypGlobalContextVariables: {
    id: curriculumProgramId,
    elementTypes: [_.get(MYP_FILTER_ENTITIES, "MYP_GLOBAL_CONTEXT")],
  },
});
export const getAssessmentSectionDetailsV2 = ({ assessment }) => {
  const lastSection = _.last(assessment);
  const lastSectionId = _.get(lastSection, "item.id", "");

  const questions = _.get(lastSection, "children", []);
  const lastQuestion = _.last(questions);
  const lastQuestionId = _.get(lastQuestion, "item.id");

  return { parentItemId: lastSectionId, putAfterItemId: lastQuestionId };
};

export const getCurriculumAndSubjectInfo = ({
  subject,
  grade,
  isMypGrade,
  organizationId,
}) => {
  const queryData = getOrganizationCurriculumProgramsFromCache(organizationId);
  const curriculumProgramData = _.get(queryData, "curriculumPrograms", []);
  let curriculumProgramId = "";
  let subjectId = _.get(subject, "mappedOrganizationEntities.[0].id");
  const gradeIds = _.map(_.get(grade, "mappedOrganizationEntities", []), "id");
  const subjectIds = _.map(
    _.filter(
      _.get(subject, "mappedOrganizationEntities", []),
      entity => _.get(entity, "curriculumProgram.type") === CURRICULUM_TYPE_MYP
    ),
    "id"
  );
  const isMYPWorksheetEnabled = isMYPWorksheetEnabledForLibrary();

  if (isMypGrade && isMYPWorksheetEnabled) {
    const mypProgram = _.find(curriculumProgramData, {
      type: CURRICULUM_TYPE_MYP,
    });
    curriculumProgramId = _.get(mypProgram, "id", "");
    subjectId = _.get(
      _.find(
        _.get(subject, "mappedOrganizationEntities", []),
        entity =>
          _.get(entity, "curriculumProgram.type") === CURRICULUM_TYPE_MYP
      ),
      "id",
      ""
    );
  }

  return {
    curriculumProgramId,
    subjectId,
    gradeIds,
    subjectIds,
  };
};

const getInitialMypSelectedKeys = ({
  filterMenuType,
  parentEntity,
  fields = [],
}) => {
  const filterKey = getFilterKeyForStorage({
    parentEntity,
    source: filterMenuType,
  });
  const savedFilters = filterKey
    ? JSON.parse(getFromStorage("toddleLibraryFilters") || "{}")
    : {};
  const defaults = _.get(savedFilters, [filterKey], {});

  const extractKeys = arr =>
    _.isArray(arr)
      ? _.map(arr, item =>
          _.isObject(item) ? _.get(item, "key", "") : item
        ).filter(Boolean)
      : [];

  return _.reduce(
    fields,
    (acc, field) => ({
      ...acc,
      [field]: extractKeys(_.get(defaults, field, [])),
    }),
    {}
  );
};

export const getInitialMypAdditionalSelectedKeys = params =>
  getInitialMypSelectedKeys({
    ...params,
    fields: [
      "relatedConcepts",
      "keyConcepts",
      "globalContext",
      "subTopics",
      ...(params.filterMenuType === QUESTION
        ? ["questionTypes", "difficulty"]
        : []),
    ],
  });

export const getMypFilterLabelCount = selectedKeys =>
  _.reduce(
    _.values(selectedKeys),
    (acc, arr) => acc + (_.isArray(arr) ? arr.length : 0),
    0
  );

export const getInitialFilterSelectedKeys = ({
  filterMenuType,
  parentEntity,
  fields = [],
}) => {
  const filterKey = getFilterKeyForStorage({
    parentEntity,
    source: filterMenuType,
  });
  const savedFilters = filterKey
    ? JSON.parse(getFromStorage("toddleLibraryFilters") || "{}")
    : {};
  const defaults = _.get(savedFilters, [filterKey], {});

  const extractKeys = arr =>
    _.isArray(arr)
      ? _.map(arr, item =>
          _.isObject(item) ? _.get(item, "key", "") : item
        ).filter(Boolean)
      : [];

  return _.reduce(
    fields,
    (acc, field) => ({
      ...acc,
      [field]: extractKeys(_.get(defaults, field, [])),
    }),
    {}
  );
};

export const getInitialAdditionalGradeFilterSelectedKeys = ({
  globalGradeLabel,
  parentEntity,
  filterMenuType,
}) => {
  const isMYPGrade = _.includes(MYP_GRADE_LABELS, globalGradeLabel);
  const isDPGrade = _.includes(DP_GRADE_LABELS, globalGradeLabel);

  const fields = isMYPGrade
    ? [
        "relatedConcepts",
        "keyConcepts",
        "globalContext",
        "subTopics",
        ...(filterMenuType === QUESTION ? ["questionTypes", "difficulty"] : []),
      ]
    : isDPGrade
    ? [
        "subTopics",
        "difficulty",
        "paperTypes",
        "subjectLevels",
        "questionTypes",
      ]
    : [];

  const result = getInitialFilterSelectedKeys({
    filterMenuType,
    parentEntity,
    fields,
  });

  // hidePrevious is stored as a boolean; convert to array form for FilterMenu selectedItemKeys
  // Apply for all grades and tabs
  const filterKey = getFilterKeyForStorage({
    parentEntity,
    source: filterMenuType,
  });
  const savedFilters = filterKey
    ? JSON.parse(getFromStorage("toddleLibraryFilters") || "{}")
    : {};
  const savedHidePrevious = _.get(
    savedFilters,
    [filterKey, "hidePrevious"],
    false
  );
  result.hidePrevious = savedHidePrevious ? ["hidePrevious"] : [];

  return result;
};

export const getAdditionalGradeFilterLabelCount = selectedKeys =>
  _.reduce(
    _.values(selectedKeys),
    (total, items) => total + (_.isArray(items) ? items.length : 0),
    0
  );

export const getFeedSectionHeaderText = ({
  count,
  searchText,
  resourceType,
}) => {
  if (!count) return;

  const key = _.isEmpty(searchText) ? "WITHOUT_SEARCH" : "WITH_SEARCH";
  const localeKey = FEED_SECTION_HEADER_LOCALES[key][resourceType];

  return (
    <Trans i18nKey={localeKey} count={count} values={{ searchText }}>
      <span style={styles.forTextStyles}>for</span>
    </Trans>
  );
};

export const getIsLibrarySearchPageRevampEnabled = () => {
  return ACLStore.can("FeatureFlag:ToddleLibrarySearchRevamp");
};

export const getIsAdditionalAllGradesFilterEnabled = () => {
  return ACLStore.can("FeatureFlag:ToddleLibraryFiltersRevamp");
};

export const getIsModuleEmpty = ({
  module,
  stage_list,
  step_list,
  allFields,
}) => {
  const stages = _.get(module, "stages", []);

  if (_.isEmpty(stages)) {
    return true;
  }

  const moduleFieldUids = _.flatMap(stages, stageKey => {
    const stageSteps = _.get(stage_list, [stageKey, "steps"], []);
    return _.flatMap(stageSteps, stepKey => {
      return _.get(step_list, [stepKey, "fields"], []);
    });
  });

  if (_.isEmpty(moduleFieldUids)) {
    return true;
  }

  const hasAnyFieldWithData = _.some(moduleFieldUids, fieldUid => {
    const field = _.find(allFields, { uid: fieldUid });
    return !_.isNil(_.get(field, "value"));
  });

  return !hasAnyFieldWithData;
};
